export interface Country {
    code: string;
    labelDe: string;
    labelEn: string;
}

export const COUNTRIES: Country[] = [
    { code: 'DE', labelDe: 'Deutschland', labelEn: 'Germany' },
    { code: 'AT', labelDe: 'Österreich', labelEn: 'Austria' },
    { code: 'CH', labelDe: 'Schweiz', labelEn: 'Switzerland' },
    { code: 'BE', labelDe: 'Belgien', labelEn: 'Belgium' },
    { code: 'CZ', labelDe: 'Tschechien', labelEn: 'Czech Republic' },
    { code: 'DK', labelDe: 'Dänemark', labelEn: 'Denmark' },
    { code: 'FI', labelDe: 'Finnland', labelEn: 'Finland' },
    { code: 'FR', labelDe: 'Frankreich', labelEn: 'France' },
    { code: 'IE', labelDe: 'Irland', labelEn: 'Ireland' },
    { code: 'IT', labelDe: 'Italien', labelEn: 'Italy' },
    { code: 'LI', labelDe: 'Liechtenstein', labelEn: 'Liechtenstein' },
    { code: 'LU', labelDe: 'Luxemburg', labelEn: 'Luxembourg' },
    { code: 'NL', labelDe: 'Niederlande', labelEn: 'Netherlands' },
    { code: 'NO', labelDe: 'Norwegen', labelEn: 'Norway' },
    { code: 'PL', labelDe: 'Polen', labelEn: 'Poland' },
    { code: 'PT', labelDe: 'Portugal', labelEn: 'Portugal' },
    { code: 'ES', labelDe: 'Spanien', labelEn: 'Spain' },
    { code: 'SE', labelDe: 'Schweden', labelEn: 'Sweden' },
    { code: 'GB', labelDe: 'Vereinigtes Königreich', labelEn: 'United Kingdom' },
];

export const getCountryLabel = (code: string, lang: string): string => {
    const country = COUNTRIES.find((c) => c.code === code);
    if (!country) return code;
    return lang === 'de' ? country.labelDe : country.labelEn;
};

export const getCountryOptions = (lang: string): string[] => {
    return COUNTRIES.map((c) => c.code);
};

export const getCountryDisplayName = (code: string, lang: string): string => {
    return getCountryLabel(code, lang);
};
